import selectEntries from "assets/mock/selectEntries.json";
import selectOutputs from "assets/mock/selectOutputs.json";
import selectOption from "assets/mock/selectOption.json";
import * as yup from "yup";

// export const cahierValidationSchema = (cashTransaction) => {
//   console.log(cashTransaction, '----------->>cash transaction')
//   return yup.object().shape({
//     cashTransaction: yup.string().required("Field is required"),
//     ["typeData"]: yup.object({
//       ...(cashTransaction === "entries" && {
//         ["type"]: yup.string().required("Field is required"),
//         ["otherReceipts"]: yup.string().when("type", {
//           is: '2',
//           then: yup.string().required("Field is required"),
//         }),
//         ["paymentMadeIn"]: yup.string().when("type", {
//           is: (selectedEntrees) => ['1','2'].includes(selectedEntrees),
//           then: yup.string().required("Field is required"),
//         }),
//         ["cost"]: yup.string().when("type", {
//           is: (selectedEntrees) => ['1','2'].includes(selectedEntrees),
//           then: yup.string().required("Field is required"),
//         }),
//       }),
//       ...(cashTransaction === "exits" && {
//         ["type"]: yup.string().required("Field is required"),
//         ["otherDisbursements"]: yup.string().when("type", {
//           is: "7",
//           then: yup.string().required("Field is required"),
//         }),
//         ["paymentMadeIn"]: yup.string().when("type", {
//           is: (selectedSorties) => ['3', '4', '5', '6', '7'].includes(selectedSorties),
//           then: yup.string().required("Field is required"),
//         }),
//         ["cost"]: yup.string().when("type", {
//           is: (selectedSorties) => ['3', '4', '5', '6', '7'].includes(selectedSorties),
//           then: yup.string().required("Field is required"),
//         }),
//       }),
//     })
//   });
// };
export const cahierValidationSchema = yup.object().shape({
  cashTransaction: yup.string().required("Field is required"),
  typeData: yup.object().when(
    "cashTransaction",
    {
      is: "ENTRIES",
      then: yup.object().shape({
        ["type"]: yup.string().required("Field is required"),
        ["otherReceipts"]: yup.string().when("type", {
          is: "2",
          then: yup.string().required("Field is required"),
        }),
        ["paymentMadeIn"]: yup.string().required("Field is required"),
        ["cost"]: yup.string().required("Field is required"),
      }),

      otherwise: yup.object().when(
        "cashTransaction",
        {
          is: "EXITS",
          then: yup.object().shape({
            ["type"]: yup.string().required("Field is required"),
            ["otherDisbursements"]: yup.string().when("type", {
              is: "140",
              then: yup.string().required("Field is required"),
            }),
            ["paymentMadeIn"]: yup.string().required("Field is required"),
            ["cost"]: yup.string().required("Field is required"),
          }),
        },
        ["cashTransaction"]
      ),
    },
    ["type"]
  ),
});

export const stockValidationSchema = (type) => {
  return yup.object().shape({
    type: yup.string().required("Field is required"),
    ["typeData"]: yup.object({
      ...(type === "entries" && {
        ["origin"]: yup.string().required("Field is required"),
        ["amount"]: yup
          .number()
          .typeError("Please enter a number")
          .required("Field is required"),
        ["unitPrice"]: yup.string().required("Field is required"),
        ["rising"]: yup.string().required("Field is required"),
      }),
      ...(type === "exits" && {
        ["destination"]: yup.string().required("Field is required"),
        ["amount"]: yup
          .number()
          .typeError("Please enter a number")
          .required("Field is required"),
        ["unitPrice"]: yup.string().required("Field is required"),
        ["rising"]: yup.string().required("Field is required"),
      }),
      ...(type === "recovery" && {
        ["rising"]: yup.string().required("Field is required"),
      }),
    }),
  });
};
export const validation = () =>
  yup.object().shape({
    type: yup.string().required("Field is required")
  });

export const stockAmountValidation = () =>
  yup.object().shape({
    typeData: yup.object().shape({
      // rising: yup.string().ensure().required('requis'),
      amount: yup.number('Pas number').required('Requis'),
      unitPrice: yup.number('Pas number').required('Requis'),
      destination: yup.string().required('Requis')
    }),
  });

// chooseSubType: yup.string().when('chooseAlphabet', {
//   is: 'B',
//   then: yup.object().shape({
//     ["origin"]: yup.string().required("Field is required"),
//     ["amount"]: yup
//       .number()
//       .typeError("Please enter a number")
//       .required("Field is required"),
//     ["unitPrice"]: yup.string().required("Field is required"),
//     ["rising"]: yup.string().required("Field is required"),
//   }),
//   otherwise: yup.string().when('type', {
//     is: 'D',
//     then: yup.string().required('field required.')
//   })
// })

// const optionalRequiredSchema = yup.object().shape({
//   type: yup.lazy(value => {
//     if (value === "entries") {
//       yup.string().required("Field is required")
//     }
//     return yup.object().shape({
//       otherData: yup.string().required()
//     });
//   })
// });
